import { render, staticRenderFns } from "./CreateNewEmployeeView.vue?vue&type=template&id=937a2f70&"
import script from "./CreateNewEmployeeView.vue?vue&type=script&lang=ts&"
export * from "./CreateNewEmployeeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports